module.exports = __webpack_public_path__ + "img/SAC-cns-2019-2.e6ac4fc4.png";